// Retained physical slots contain only symbols and mounted listeners, never owners.
// Existing autosave scopes share this contract with scheduling's explicit writers.
export const SCHEDULE_WRITE_SCOPE = 'schedule-configuration';
type Scope = string | symbol;
const writes = new Map<Scope, symbol>();
const listeners = new Map<Scope, Set<() => void>>();
function publish(scope: Scope) { for (const listener of [...(listeners.get(scope) ?? [])]) listener(); }
export function getPhysicalWrite(scope: Scope): symbol | undefined { return writes.get(scope); }
export function acquirePhysicalWrite(scope: Scope, operation: symbol): boolean {
  if (writes.has(scope)) return false;
  writes.set(scope, operation); publish(scope); return true;
}
export function releasePhysicalWrite(scope: Scope, operation: symbol): void {
  if (writes.get(scope) !== operation) return;
  writes.delete(scope); publish(scope);
}
export function subscribePhysicalWrite(scope: Scope, listener: () => void): () => void {
  const subscribers = listeners.get(scope) ?? new Set<() => void>();
  subscribers.add(listener); listeners.set(scope, subscribers);
  return () => { subscribers.delete(listener); if (!subscribers.size) listeners.delete(scope); };
}
